<template>
  <div>
    <form method="post">
      <h3>Добавить эксперта</h3>
      <div class="field">
        <input name="search_username" v-model="expertLogin" class="input search_textfield" type="text"
               placeholder="Логин">
      </div>
      <div class="field">
        <input name="search_username" v-model="expertPassword" class="input search_textfield" type="text"
               placeholder="Пароль">
      </div>
      <div class="field">
        <input name="search_username" v-model="expertLastname" class="input search_textfield" type="text"
               placeholder="Фамилия">
      </div>
      <div class="field">
        <input name="search_username" v-model="expertFirstname" class="input search_textfield" type="text"
               placeholder="Имя">
      </div>
      <div class="field">
        <input name="search_username" v-model="expertSurname" class="input search_textfield" type="text"
               placeholder="Отчество">
      </div>
      <div class="field">
        <input name="search_username" v-model="expertPhone" class="input search_textfield" type="text"
               placeholder="Телефон">
      </div>
      <input :disabled="loading" @click.prevent="addExpert" value="Добавить" type="submit"
             class="button search_button is-info">
    </form>

    <hr>
	  
	  <div class="field">
      <Input v-model:value="search_username" placeholder="Email (логин)" />
	  </div>
    <div class="field">
	    <Input v-model:value="search_lastname" placeholder="Фамилия" />
    </div>
	  <div class="field">
      <Input v-model:value="search_firstname" placeholder="Имя" />
	  </div>
	  <div class="field">
      <Input v-model:value="search_surname" placeholder="Отчество" />
	  </div>
	  
	  
    <div class="table_wrapper">
	    <Table
        :columns="columns"
        :data-source="filteredUsers"
        :scroll="{ x: '100%', y: 400 }"
        @change="handleTableChange"
        :loading="loading"
	  >
		  <template #bodyCell="{ column, record }">
		    <template v-if="column.key === 'username'">
			    <div>
            <img v-if="record.avatar" style="width: 40px; height: 40px; border-radius: 50px; margin-right: 10px;" :src="'https://cdn.moviestart.ru/uploads/images/'+record.avatar" />
            <img style="width: 40px; height: 40px; border-radius: 50px; margin-right: 10px;" v-else src="https://script.moviestart.ru/images/anonym.png" />
			    </div>
		       {{ record.lastName }} {{ record.firstName }} {{ record.patronymic }} <br>{{ record.username }}
		    </template>
        <template v-if="column.key === 'roles'">
					{{ getUserRoles(record.roles).join(', ') }}
        </template>
        <template v-if="column.key === 'block'">
	        <Checkbox :checked="record.isBanned" @change="(e) => blockUser(e, record)" />
        </template>
        <template v-if="column.key === 'voteBlock'">
	        <template v-if="userService.hasRole('ROLE_EXPERT', record)">
            <Checkbox :checked="record.userData?.['disable_vote']" @change="(e) => voteExpertAllow(e, record)" />
	        </template>
        </template>
        <template v-if="column.key === 'phoneConfirm'">
          <Checkbox :checked="record.isPhoneVerified" @change="(e) => isPhoneVerified(e, record)" />
        </template>
			  <template v-if="column.key === 'registerDate'">
				  {{ getFormatedDate(record.registerDate) }}
			  </template>
        <template v-if="column.key === 'actions'">
          <a style="margin-right: 35px;" :href="'/info/user/'+record.id"><i class="fas fa-eye"></i></a><br>
          <a class="delete_link" :href="'/admin/delete/'+record.id"><i class="fas fa-trash-alt"></i></a>
        </template>
		  </template>
	  </Table>
    </div>
  </div>
</template>

<script setup>
import {ref, computed } from 'vue';
import axios from 'axios';
import {message, Table, Checkbox, Input, Button } from 'ant-design-vue';
import userService from "@/services/userService"
import moment from 'moment';

const expertLogin = ref('');
const expertPassword = ref('');
const expertLastname = ref('');
const expertFirstname = ref('');
const expertSurname = ref('');
const expertPhone = ref('');
const loading = ref(false);
const users = ref([]);

const search_username = ref('');
const search_lastname = ref('');
const search_firstname = ref('');
const search_surname = ref('');

const columns = ref([
  {
    title: 'Пользователь',
    dataIndex: 'username',
    key: 'username',
	  width: '200px'
  },
  {
    title: 'Роли',
    dataIndex: 'roles',
    key: 'roles',
    filters: [
      { text: 'Участник', value: 'ROLE_PARTICIPANT' },
      { text: 'Организатор', value: 'ROLE_ORGANIZATOR' },
      { text: 'Эксперт', value: 'ROLE_EXPERT' },
    ]
  },
  {
    title: 'Заблокировать',
    dataIndex: 'block',
    key: 'block',
  },
  {
    title: 'Запрет оценок',
    dataIndex: 'voteBlock',
    key: 'voteBlock',
  },
  {
    title: 'Телефон подтвержден',
    dataIndex: 'phoneConfirm',
    key: 'phoneConfirm',
  },
  {
    title: 'Дата регистрации',
    dataIndex: 'registerDate',
    key: 'registerDate',
  },
  {
    title: 'Действия',
    dataIndex: 'actions',
    key: 'actions',
  },
  
]);

async function getUsers() {
  loading.value = true
	const response = await axios.get('/admin_users_get_all');
	users.value = response.data;
  loading.value = false;
}
getUsers();

const filteredUsers = computed(() => {
  return users.value.filter(user => {
    return (
      (search_username.value === '' || (user.username && user.username.toLowerCase().includes(search_username.value.toLowerCase()))) &&
      (search_lastname.value === '' || (user.lastName && user.lastName.toLowerCase().includes(search_lastname.value.toLowerCase()))) &&
      (search_firstname.value === '' || (user.firstName && user.firstName.toLowerCase().includes(search_firstname.value.toLowerCase()))) &&
      (search_surname.value === '' || (user.patronymic && user.patronymic.toLowerCase().includes(search_surname.value.toLowerCase())))
    );
  });
});

function getUserRoles(roles) {
  let res = [];
  return roles.map(role => {
    return userService.getUserRoleLabelByRole(role);
  })
}

function getFormatedDate(date) {
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

const addExpert = async () => {
  loading.value = true;
  try {
    const response = await axios.post('/new_expert', null, {
      params: {
        expert_login: expertLogin.value,
        expert_password: expertPassword.value
      }
    });
    if (typeof response.data === "string") {
      message.error(response.data);
    } else {
      window.location.reload();
    }
  } catch (error) {
    message.error('An error occurred');
  } finally {
    loading.value = false;
  }
};

async function blockUser(e, record) {

  await axios.patch('/api/users/' + record.id,
    {
      isBanned: e.target.checked
    },
    {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
    .catch(function (error) {
	    alert('Ошибка сохранения данных');
      console.log('Ошибка получения данных');
    });
  getUsers();
}

async function voteExpertAllow(e, record) {

	await axios.post('/admin/make_expert_voting', null, {
    params: {
      user_id: record.id
    }
  })
    .catch(function (error) {
      console.log('Ошибка получения данных');
    });
  getUsers();
}

async function isPhoneVerified(e, record) {
  await axios.patch('/api/users/' + record.id,
    {
      isPhoneVerified: e.target.checked
    },
    {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
    .catch(function (error) {
      alert('Ошибка сохранения данных');
      console.log('Ошибка получения данных');
    });
  getUsers();
}

async function handleTableChange(pagination, filters) {
  await getUsers();

  const { roles } = filters;

  users.value = users.value.filter(record => {
    if (roles && roles.length > 0) {
      return record.roles.includes(roles[0]);
    }
    return true;
  });
}


</script>

<style scoped>
.table_wrapper {
    position: relative;
    overflow-x: auto;
    width: 100%
}
</style>